import defaultSettings from '@/settings'

const title = defaultSettings.title || '川渝创新资源服务平台'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}



// WEBPACK FOOTER //
// ./src/user/utils/get-page-title.js